import { CLINICAL_LEAD_COLUMNS } from './config';
import { CLNameCell } from './CLNameCell';
import { CLOrganIcons } from './CLOrganIcons';
import { CLReservationCondition } from './CLReservationCondition';
import { CLAssignButton } from './CLAssignButton';
import { displayPhoneNumber } from '@/utils/helpers';
import { CLAssignmentCandidate } from '@/api/apis/resources';

export type ClinicalLeadRowData = {
  isSelected: boolean;
  isPrimary: boolean;
} & CLAssignmentCandidate;

export const renderClinicalLeadTableCell =
  (onAssign: (lead: ClinicalLeadRowData) => void) => (item: ClinicalLeadRowData, columnKey: string) => {
    const {
      employeeFullName,
      employeeProfilePhoto,
      isSelected,
      isPrimary,
      csOrganCertificates,
      phoneSupportOrganCertificates,
      phone,
      csActiveReservationCase,
      overlapOnCallShiftStart,
      overlapOnCallShiftEnd,
      phoneSupportStart,
      phoneSupportEnd,
    } = item;

    switch (columnKey) {
      case CLINICAL_LEAD_COLUMNS.name.key:
        return (
          <CLNameCell
            name={employeeFullName!}
            photo={employeeProfilePhoto!}
            isPrimary={isPrimary}
            csOrganCertificates={csOrganCertificates}
          />
        );
      case CLINICAL_LEAD_COLUMNS.clinicalLeadOrgan.key:
        return <CLOrganIcons organs={phoneSupportOrganCertificates} />;
      case CLINICAL_LEAD_COLUMNS.phone.key:
        return <span>{phone ? displayPhoneNumber(phone) : '-'}</span>;
      case CLINICAL_LEAD_COLUMNS.reservationCondition.key:
        return (
          <CLReservationCondition
            csActiveReservationCase={csActiveReservationCase}
            overlapOnCallShiftStart={overlapOnCallShiftStart}
            overlapOnCallShiftEnd={overlapOnCallShiftEnd}
            phoneSupportStart={phoneSupportStart}
            phoneSupportEnd={phoneSupportEnd}
          />
        );
      case CLINICAL_LEAD_COLUMNS.action.key:
        return <CLAssignButton isSelected={isSelected} onAssign={() => onAssign(item)} />;
      default:
        return null;
    }
  };
